import { render, staticRenderFns } from "./borang_acu.vue?vue&type=template&id=14903fc0&"
import script from "./borang_acu.vue?vue&type=script&lang=js&"
export * from "./borang_acu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports